export const faqs = [
  {
    id: 'faq-1',
    question: '草榴社区入口地址经常变动吗？',
    answer: '是的，由于网络环境的持续变化，入口地址可能会定期更新。我们建议您收藏本导航网站，我们会第一时间更新最新的可用入口地址，确保您随时都能访问。',
  },
  {
    id: 'faq-2',
    question: '如何知道哪个入口速度最快？',
    answer: '您可以使用 ping 命令测试各入口的响应时间，响应时间越短速度越快。通常离您物理位置最近的镜像节点速度最佳。本站也会标注各入口的当前状态，方便您选择。',
  },
  {
    id: 'faq-3',
    question: '访问草榴社区需要注册账号吗？',
    answer: '浏览部分公开内容不需要注册，但如果想参与讨论、发帖或查看完整内容，则需要注册账号。注册过程简单快捷，只需邮箱即可。',
  },
  {
    id: 'faq-4',
    question: '使用代理工具访问安全吗？',
    answer: '选择信誉良好的代理服务商，并注意不在代理环境下输入敏感个人信息（如银行卡信息），整体来说是安全的。建议避免使用不明来源的免费代理。',
  },
  {
    id: 'faq-5',
    question: '手机上如何访问草榴社区？',
    answer: '手机访问与电脑类似，可通过浏览器直接访问入口地址。如果遇到访问困难，可在手机上安装支持代理的浏览器或使用 VPN App。部分入口已针对移动端做了优化。',
  },
  {
    id: 'faq-6',
    question: '入口页面显示"您的连接不是私密连接"怎么办？',
    answer: '这通常是SSL证书问题或中间人攻击的警告。首先确认您访问的是正确的官方入口地址，如果确认无误，可能是证书配置问题，建议更换其他入口尝试。',
  },
  {
    id: 'faq-7',
    question: '草榴社区支持哪些语言？',
    answer: '草榴社区主要使用简体中文，部分版块支持繁体中文。社区内容以中文为主，方便华语用户交流。',
  },
  {
    id: 'faq-8',
    question: '如何获取草榴社区的最新公告？',
    answer: '您可以在社区首页查看置顶公告，或关注本站的"社区动态"栏目，我们会及时同步社区的重要更新和公告信息。',
  },
];